import {
	MessageBackend,
	MessageFrontend,
} from '@post-office/message-template--nav-4-projects-section-recommendation/placements/in-app-v2/nav-4-projects-section';
import { productionRuntime } from '@post-office/placement-common-v2/placement-runtime';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth/nav-4-projects-section';

import { withI18n } from './i18n';

const messageBackends = [
	MessageBackend({
		messageTemplateId: 'nav-4-projects-section-recommendation',
	}),
];

const messageFrontends = [
	MessageFrontend({
		messageTemplateId: 'nav-4-projects-section-recommendation',
	}),
];

export const placementBackendFactory = PlacementBackend.createPlacementBackend({
	messageTemplates: messageBackends,
});

export const RawPlacement = PlacementFrontend.createPlacementFrontendComponent({
	messageTemplates: messageFrontends,
});

export const Placement = withI18n(RawPlacement);

export const SSRPlacement = RawPlacement;

export const middleware = placementBackendFactory(productionRuntime);
